import type { FC } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import DialogBanner from '@wix/da-ds/pkg/DialogBanner';
import Refresh from '@wix/da-ds/pkg/Icons/24x24/Refresh';
import { getRunningBatchCount } from '../../selectors/studio';

import s from './StudioTableBatchBanner.scss';

export interface Props {}

const StudioTableBatchBanner: FC<Props> = () => {
  const { t } = useTranslation();
  const batchCount = useSelector(getRunningBatchCount);

  if (batchCount < 1) {
    return null;
  }

  return (
    <DialogBanner
      className={s['root']}
      message={
        <p className={s['message']}>
          <Refresh disableDefaultColors />
          {t('studio.header.updating')}
        </p>
      }
    />
  );
};
StudioTableBatchBanner.displayName = 'StudioTableBatchBanner';
export default StudioTableBatchBanner;
